(() => {
  const cartTitleSelector = '.cart-item__title a, .cart-item__title .text-current';
  const snapProductNameSelector = [
    '.item-manager-snap-modal__product-name',
    '.item-manager-coordinate-items__product .product-block__title'
  ].join(',');
  const snapBrandSelector = '.item-manager-snap-modal__product-brand';
  const snapCaptionSelector = '.item-manager-snap-modal__caption';

  // Containers that hold the nodes sanitize() rewrites. Observing only these
  // (instead of the whole document.body) keeps unrelated page activity such as
  // countdown timers, sliders and announcement bars from triggering a rescan.
  const rootSelectors = ['cart-drawer', '[data-snap-modal-root]', '.item-manager-coordinate-items'];

  const withSinglePreOrderSpace = (value) => {
    const text = String(value || '');
    const hasPreOrder = /PRE\s*ORDER|PREORDER/i.test(text);
    const productName = text
      .replace(/\s*PRE\s*ORDER\s*/gi, ' ')
      .replace(/\s*PREORDER\s*/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return hasPreOrder && productName ? `${productName} PRE ORDER` : productName;
  };

  const withoutPreOrder = (value) =>
    String(value || '')
      .replace(/\s*PRE\s*ORDER\s*/gi, ' ')
      .replace(/\s*PREORDER\s*/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const withoutBrandLines = (value) =>
    String(value || '')
      .split(/\r?\n/)
      .filter((line) => !/^\s*en[\s_-]*neume\s*$/i.test(line))
      .join('\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();

  const setText = (element, nextText) => {
    if (!element || element.textContent === nextText) return;
    element.textContent = nextText;
  };

  const sanitize = () => {
    document.querySelectorAll(cartTitleSelector).forEach((element) => {
      setText(element, withSinglePreOrderSpace(element.textContent));
    });

    document.querySelectorAll(snapProductNameSelector).forEach((element) => {
      setText(element, withoutPreOrder(element.textContent));
    });

    document.querySelectorAll(snapBrandSelector).forEach((element) => {
      element.remove();
    });

    document.querySelectorAll(snapCaptionSelector).forEach((element) => {
      setText(element, withoutBrandLines(element.textContent));
    });
  };

  let sanitizeScheduled = false;

  const scheduleSanitize = () => {
    if (sanitizeScheduled) return;
    sanitizeScheduled = true;
    requestAnimationFrame(() => {
      sanitizeScheduled = false;
      sanitize();
    });
  };

  const observedRoots = new WeakSet();

  const observeRoots = () => {
    if (typeof MutationObserver !== 'function') return;
    rootSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((root) => {
        if (observedRoots.has(root)) return;
        observedRoots.add(root);
        const observer = new MutationObserver(scheduleSanitize);
        observer.observe(root, { childList: true, subtree: true });
      });
    });
  };

  const init = () => {
    sanitize();
    observeRoots();
  };

  document.addEventListener('on:cart:after-merge', scheduleSanitize);
  document.addEventListener('on:cart:change', scheduleSanitize);
  document.addEventListener('shopify:section:load', () => {
    observeRoots();
    scheduleSanitize();
  });
  document.addEventListener('item-manager:snap-modal-ready', () => {
    observeRoots();
    scheduleSanitize();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
